import { render, staticRenderFns } from "./ShareholderInformation.vue?vue&type=template&id=1b8e7e7b&"
import script from "./ShareholderInformation.vue?vue&type=script&lang=ts&"
export * from "./ShareholderInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports